<template>
  <div class="container">
    <vue-slick-carousel v-bind="settings" id="carousel-herocard">
      <div class="herocard-box" v-for="(card, index) in cards" :key="index">
        <CardCarouselItem :image="card"></CardCarouselItem>
      </div>
    </vue-slick-carousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import CardCarouselItem from "./CardCarouselItem.vue";

export default {
  data() {
    return {
      settings: {
        dots: false,
        infinite: false,
        initialSlide: 0,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: false,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 576, settings: { slidesToShow: 1 } },
        ],
      },
      directionClass: "",
      cards: [
        "/assets/images/card/1.webp",
        "/assets/images/card/2.webp",
        "/assets/images/card/3.webp",
        "/assets/images/card/4.webp",
        "/assets/images/card/5.webp",
        "/assets/images/card/6.webp",
        "/assets/images/card/7.webp",
        "/assets/images/card/8.webp",
        "/assets/images/card/9.webp",
        "/assets/images/card/10.webp",
        "/assets/images/card/11.webp",
      ],
    };
  },
  components: {
    VueSlickCarousel,
    CardCarouselItem,
  },
};
</script>
